import React from 'react';
import PropTypes from 'prop-types';
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash, faGripVertical } from '@fortawesome/free-solid-svg-icons';
import { AccountType } from 'models';
import { TEXT_ROLE_ADMIN, TEXT_ROLE_MANAGER, TEXT_ROLE_USER } from 'constants/message';
import "./UserList.css"; // Use the same CSS as UserList

const propTypes = {
    item: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    selectedUser: PropTypes.object,
    onEditItem: PropTypes.func.isRequired,
    onDeleteItem: PropTypes.func.isRequired,
    setSelectedUser: PropTypes.func.isRequired,
    formatTimestamp: PropTypes.func.isRequired,
    dragDisabled: PropTypes.bool,
    onShowLoginHistory: PropTypes.func.isRequired,
};

const DragDropUserItem = (props) => {
    const { item, currentUser, selectedUser, onEditItem, onDeleteItem, setSelectedUser, formatTimestamp, dragDisabled = false, onShowLoginHistory } = props;

    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({
        id: item.id,
        disabled: dragDisabled // Disable sortable when dragDisabled is true
    });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={`user_list_item_wrapper ${isDragging ? 'dragging' : ''}`}
        >
            <div className='user_list_item'>
                <div
                    className='drag_handle'
                    {...(!dragDisabled ? attributes : {})}
                    {...(!dragDisabled ? listeners : {})}
                    style={{
                        cursor: dragDisabled ? 'not-allowed' : 'grab',
                        color: dragDisabled ? '#ccc' : '#999',
                        opacity: dragDisabled ? 0.5 : 1
                    }}
                >
                    <FontAwesomeIcon icon={faGripVertical} />
                </div>
                <label className='user_list_id_cell'>
                    {item.data?.displayOrder}
                </label>
                <label
                    onClick={() => { onEditItem(item) }}
                    className='user_list_text_cell text-link'>
                    {item.name}
                </label>
                <label className='user_list_text_cell'>
                    {item.accountType === AccountType.ADMIN ? TEXT_ROLE_ADMIN : item.accountType === AccountType.MANAGER ? TEXT_ROLE_MANAGER : TEXT_ROLE_USER}
                </label>
                <label className='user_list_text_cell'>
                    {!item.enabledMFA ? '無効' : '有効'}
                </label>
                {item?.data?.lastTimeLogin ? (
                    <button
                        onClick={() => onShowLoginHistory(item)}
                        className="user_list_text_cell text-link"
                        style={{ cursor: 'pointer', border: 'none', background: 'none', textAlign: 'left', padding: 0 }}
                    >
                        {formatTimestamp(item.data.lastTimeLogin)}
                    </button>
                ) : (
                    <label className='user_list_text_cell' />
                )}
                <label className='user_list_text_cell'>
                    {item.email}
                </label>
                <label className="user_list_text_cell">
                    <input
                        type="radio"
                        name="deviceConfiguration"
                        style={{ width: '20px', height: '20px', display: 'block', margin: 'auto' }}
                        onChange={() => setSelectedUser({
                            id: item.id,
                            email: item.email,
                            nameList: item?.data?.nameList || [],
                            labelArea: item?.data?.labelArea || ""
                        })}
                        checked={selectedUser?.id === item.id}
                    />
                </label>
                <label className='user_list_text_cell'>
                    {item.description}
                </label>
                <label className='user_list_date_cell' style={{ whiteSpace: 'nowrap' }}>
                    {(() => {
                        if (!item.updatedAt) return '';
                        const date = new Date(item.updatedAt);
                        const month = ('0' + (date.getMonth() + 1)).slice(-2);
                        const day = ('0' + date.getDate()).slice(-2);
                        return `${month}/${day}`;
                    })()}
                </label>
                <div className='user_list_action_cell'>
                    <button
                        className='user_list_button_delete'
                        disabled={item.id === currentUser.id || (currentUser.accountType === AccountType.MANAGER && item.accountType === AccountType.ADMIN)}
                        onClick={() => { onDeleteItem(item) }}
                        title='ユーザー削除'>
                        <FontAwesomeIcon icon={faTrash} />
                    </button>
                </div>
            </div>
            <div className='user_list_item_separator' />
        </div>
    );
};

DragDropUserItem.propTypes = propTypes;
export default DragDropUserItem;
